import { EMPTY_FIELD } from 'constants/emptyField';

import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import { Colors, useGetActivityColor } from 'pages/ApiClients/hooks/useGetActivityColor';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';

type Props = {
  activityUpdatedAtColor: Colors;
  activityUpdatedAtMessage: string;
};

export const ApiClientsLastActivityActive: React.FC<Props> = ({
  activityUpdatedAtColor,
  activityUpdatedAtMessage,
}) => {
  const { getColor } = useGetActivityColor();

  return (
    <Stack alignItems="start" direction="row" gap={1}>
      <MonitorHeartOutlinedIcon htmlColor={getColor('icon', activityUpdatedAtColor)} />
      <Typography color={getColor('text', activityUpdatedAtColor)} component="span">
        {activityUpdatedAtMessage || EMPTY_FIELD}
      </Typography>
    </Stack>
  );
};
